import React, { useState } from "react";
import { Shield, Trash2, Save, AlertTriangle, Eye, EyeOff } from "lucide-react";
import Header from "../Profile/Header";
import PasswordChangeForm from "./PasswordChangeForm";
import DeleteAccountModal from "./DeleteAccountModal";
import TopPicks from "../Profile/TopPicks";

const Settings = () => {
  const [activeSection, setActiveSection] = useState("security");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [notifications, setNotifications] = useState({
    email: true,
    sms: false,
    push: true,
    marketing: false,
  });

  const [privacy, setPrivacy] = useState({
    profileVisibility: "public",
    showEmail: false,
    showPhone: false,
    dataCollection: true,
  });

  const handleNotificationChange = (key, value) => {
    setNotifications((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handlePrivacyChange = (key, value) => {
    setPrivacy((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSaveNotifications = () => {
    console.log("Saving notifications:", notifications);
    alert("Notification preferences saved!");
  };

  const handleSavePrivacy = () => {
    console.log("Saving privacy settings:", privacy);
    alert("Privacy settings saved!");
  };

  const handleDeleteAccount = () => {
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = (password) => {
    console.log("Deleting account with password verification");
    // In real app, verify password and delete account
    alert(
      "Account deletion process initiated. You will receive a confirmation email.",
    );
    setIsDeleteModalOpen(false);
  };

  return (
    <div className="relative mx-auto my-0 bg-orange-50 bg-opacity-90 h-auto pb-8 w-full">
      {/* Header */}
      <Header activeSection="settings" />

      {/* Main Settings Content */}
      <main className="relative mx-auto w-[90%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%] mt-6 md:mt-1 px-4 md:px-0">
        {/* Page Header */}
        <header className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-between items-start sm:items-center w-full text-teal-800 mb-6 md:mb-4 mx-auto">
          <div className="flex items-center gap-2">
          <Shield className="w-8 h-8 text-teal-600" />                
          <h1
            className="text-2xl md:text-3xl lg:text-4xl tracking-wider text-center font-bold text-teal-800  py-2"
            // style={{
            //   WebkitTextStroke: "1px white",
            //   textStroke: "1px white",
            // }}
          >
            Settings
          </h1>
          </div>
          
          
        </header>

        {/* Settings Navigation */}
        {/* <nav className="bg-white bg-opacity-60 rounded-xl border border-orange-200 p-4 mb-8 hover:shadow-2xl hover:shadow-orange-200/50 transition-all duration-300" aria-label="Settings navigation">
          <div className="flex flex-wrap gap-2">
            {[
              { id: 'security', label: 'Security', icon: Shield },
              { id: 'notifications', label: 'Notifications', icon: MessageSquare },
              { id: 'privacy', label: 'Privacy', icon: Eye },
              { id: 'reporting', label: 'Report Issue', icon: MessageSquare },
              { id: 'danger', label: 'Account', icon: AlertTriangle }
            ].map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                onClick={() => setActiveSection(id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 ${
                  activeSection === id
                    ? 'bg-teal-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:shadow-md'
                }`}
                aria-current={activeSection === id ? 'page' : undefined}
              >
                <Icon className="w-4 h-4" />
                <span className="text-sm font-medium">{label}</span>
              </button>
            ))}
          </div>
        </nav> */}

        {/* Settings Content */}
        <div className="space-y-8">
          {/* Security Section */}

          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl hover:shadow-orange-200/50 transition-all duration-300"
            aria-labelledby="security-heading"
          >
            <div className="p-4 border-b border-gray-100 bg-gradient-to-r from-teal-50 to-orange-50">
              <h2
                id="security-heading"
                className="text-xl font-semibold text-gray-900 flex items-center gap-2"
              >
                {/* <Shield className="w-5 h-5 text-teal-600" /> */}
                Security Settings
              </h2>
              <p className="text-sm text-gray-600 mt-1">
                Manage your password and account security
              </p>
            </div>
            <PasswordChangeForm />
          </section>

          {/* Notifications Section */}

          {/* <section className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl hover:shadow-orange-200/50 transition-all duration-300" aria-labelledby="notifications-heading">
              <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-teal-50 to-orange-50">
                <h2 id="notifications-heading" className="text-xl font-semibold text-gray-900 flex items-center gap-2">
                  <MessageSquare className="w-5 h-5 text-teal-600" />
                  Notification Preferences
                </h2>
                <p className="text-sm text-gray-600 mt-1">Choose how you want to be notified</p>
              </div>

              <div className="p-6 space-y-6">
                {[
                  { key: 'email', label: 'Email Notifications', description: 'Receive order updates and promotions via email' },
                  { key: 'sms', label: 'SMS Notifications', description: 'Get text messages for important updates' },
                  { key: 'push', label: 'Push Notifications', description: 'Browser notifications for real-time updates' },
                  { key: 'marketing', label: 'Marketing Communications', description: 'Promotional offers and new product announcements' }
                ].map(({ key, label, description }) => (
                  <div key={key} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                    <div className="flex-1">
                      <h3 className="font-medium text-gray-900">{label}</h3>
                      <p className="text-sm text-gray-600 mt-1">{description}</p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={notifications[key]}
                        onChange={(e) => handleNotificationChange(key, e.target.checked)}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-teal-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-teal-600"></div>
                    </label>
                  </div>
                ))}

                <button
                  onClick={handleSaveNotifications}
                  className="w-full flex items-center justify-center gap-2 bg-teal-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-teal-700 hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                >
                  <Save className="w-5 h-5" />
                  Save Notification Preferences
                </button>
              </div>
            </section>
           */}

          {/* Privacy Section */}

          {/* <section className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl hover:shadow-orange-200/50 transition-all duration-300" aria-labelledby="privacy-heading">
              <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-teal-50 to-orange-50">
                <h2 id="privacy-heading" className="text-xl font-semibold text-gray-900 flex items-center gap-2">
                  <Eye className="w-5 h-5 text-teal-600" />
                  Privacy Settings
                </h2>
                <p className="text-sm text-gray-600 mt-1">Control your privacy and data sharing preferences</p>
              </div>

              <div className="p-6 space-y-6">

                <div className="p-4 bg-gray-50 rounded-lg">
                  <h3 className="font-medium text-gray-900 mb-3">Profile Visibility</h3>
                  <div className="space-y-2">
                    {[
                      { value: 'public', label: 'Public', description: 'Anyone can see your profile' },
                      { value: 'private', label: 'Private', description: 'Only you can see your profile' },
                      { value: 'friends', label: 'Friends Only', description: 'Only your connections can see your profile' }
                    ].map(({ value, label, description }) => (
                      <label key={value} className="flex items-center gap-3 cursor-pointer">
                        <input
                          type="radio"
                          name="profileVisibility"
                          value={value}
                          checked={privacy.profileVisibility === value}
                          onChange={(e) => handlePrivacyChange('profileVisibility', e.target.value)}
                          className="text-teal-600 focus:ring-teal-500"
                        />
                        <div>
                          <div className="font-medium text-gray-900">{label}</div>
                          <div className="text-sm text-gray-600">{description}</div>
                        </div>
                      </label>
                    ))}
                  </div>
                </div>


                <div className="space-y-4">
                  {[
                    { key: 'showEmail', label: 'Show Email Address', description: 'Allow others to see your email address' },
                    { key: 'showPhone', label: 'Show Phone Number', description: 'Allow others to see your phone number' },
                    { key: 'dataCollection', label: 'Allow Data Collection', description: 'Help us improve our services by collecting usage data' }
                  ].map(({ key, label, description }) => (
                    <div key={key} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                      <div className="flex-1">
                        <h3 className="font-medium text-gray-900">{label}</h3>
                        <p className="text-sm text-gray-600 mt-1">{description}</p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={privacy[key]}
                          onChange={(e) => handlePrivacyChange(key, e.target.checked)}
                          className="sr-only peer"
                        />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-teal-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-teal-600"></div>
                      </label>
                    </div>
                  ))}
                </div>

                <button
                  onClick={handleSavePrivacy}
                  className="w-full flex items-center justify-center gap-2 bg-teal-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-teal-700 hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                >
                  <Save className="w-5 h-5" />
                  Save Privacy Settings
                </button>
              </div>
            </section> */}

          {/* Danger Zone */}

          <section
            className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl hover:shadow-red-200/50 transition-all duration-300"
            aria-labelledby="danger-heading"
          >
            <div className="p-4 border-b border-gray-100 bg-gradient-to-r from-red-50 to-orange-50">
              <h2
                id="danger-heading"
                className="text-xl font-semibold text-red-900 flex items-center gap-2"
              >
                <AlertTriangle className="w-5 h-5 text-red-600" />
                Danger Zone
              </h2>
              <p className="text-sm text-red-600 mt-1">
                Irreversible and destructive actions
              </p>
            </div>

            <div className="p-6">
              <div className="border border-red-200 rounded-lg p-6 bg-red-50">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <Trash2 className="w-6 h-6 text-red-600" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-red-900 mb-2">
                      Delete Account
                    </h3>
                  </div>
                </div>
                  <div>
                    <p className="text-sm text-red-700 mb-4">
                      Once you delete your account, there is no going back.
                      Please be certain. This action will:
                    </p>
                    <ul className="text-sm text-red-700 mb-6 space-y-1 list-disc list-inside">
                      <li>Permanently delete your profile and account data</li>
                      <li>Remove all your orders and purchase history</li>
                      <li>Delete your saved addresses and payment methods</li>
                    </ul>
                    <button
                      onClick={handleDeleteAccount}
                      className="flex items-center gap-2 bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                    >
                      <Trash2 className="w-5 h-5" />
                      Delete My Account
                    </button>
                  </div>
                
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Delete Account Modal */}
      <DeleteAccountModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {/* Top Picks Section */}
    </div>
  );
};

export default Settings;
